import { Typography, Alert, Spin } from "antd";
import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/Common/PageHeader";
import { useFinanceStats } from "../hooks/useFinanceStats";
import FinanceStatsPanel from "../components/FinanceStatsPanel";
import OverviewTabs from "../components/OverviewTabs";
import { useEffect } from "react";
import { all_routes } from "router/all_routes";
import { useAbility } from "config/abilityContext";

const FinanceOverview: React.FC = () => {
  const { t } = useTranslation();
  const ability = useAbility();
  const { overview, loading: statsLoading, error, fetchFinanceOverview } = useFinanceStats();
  const breadcrumbItems = [
    { label: "finance_dashboard", path: all_routes.financeDashboard },
    { label: "finance_overview", active: true },
  ];

  useEffect(() => {
    fetchFinanceOverview();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={t("finance_overview")}
          breadcrumbItems={breadcrumbItems}
        />

        {error && (
          <Alert
            message="Error"
            description={error}
            type="error"
            showIcon
            className="mb-4"
          />
        )}

        {/* Stats Panel */}
        <FinanceStatsPanel
          stats={overview?.overview || null}
          loading={statsLoading}
        />

        <div className="row mt-4">
          {statsLoading ? (
            <div className="text-center p-4">
              <Spin size="large" />
            </div>
          ) : (
            <OverviewTabs
              feeData={overview?.recentEntries.fees || []}
              expenseData={overview?.recentEntries.expenses || []}
              unpaidFeeData={overview?.recentEntries.pendingFees || []}
              unpaidExpenseData={overview?.recentEntries.pendingExpenses || []}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FinanceOverview;
